import './Category.css';
import React from 'react';

const Category = () => {
    return (
        <section className="category-container p-3 pt-4">

            <div className="cat-item">
                <img src="https://i.ibb.co/pJX4tFC/banner-09-644x450-crop-center.jpg" alt="" />
                <h3>ROUND</h3>
                <p>From $12.89</p>
            </div>
            <div className="cat-item">
                <img src="https://i.ibb.co/rHcyQfB/banner-10-644x450-crop-center.jpg" alt="" />
                <h3>WAYFARER</h3>
                <p>From $12.89</p>
            </div>
            <div className="cat-item">
                <img src="https://i.ibb.co/5YHKDwP/banner-11-644x450-crop-center.jpg" alt="" />
                <h3>CATS</h3>
                <p>From $12.89</p>
            </div>
            <div className="cat-item">
                <img src="https://i.ibb.co/BqjkLFc/banner-12-644x450-crop-center.jpg" alt="" />
                <h3>SQUARED</h3>
                <p>From $12.89</p>
            </div>
            <div className="cat-item">
                <img src="https://i.ibb.co/vJzQym9/banner-13-644x450-crop-center.jpg" alt="" />
                <h3>AVIATOR</h3>
                <p>From $12.89</p>
            </div>
            <div className="cat-item">
                <img src="https://i.ibb.co/fXM7cb5/banner-14-644x450-crop-center.jpg" alt="" />
                <h3>RIMLESS</h3>
                <p>From $12.89</p>
            </div>

        </section>
    );
};

export default Category;